const DEFAULT_HOST = 'http://localhost:5030';

export default class Config {
  private static instance: Config;

  /**
   * Retrieve the shared config object
   * @return Config the shared config object
   */
  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }

    return Config.instance;
  }

  /**
   *  Retrieve the url of the coordination service
   *  @return string the url of the coordination service
   */
  getCoordinationServiceURL(): string {
//    console.log('get coordination url', DEFAULT_HOST, process.env.REACT_APP_COORDINATION_SERVICE_URL)
    return process.env.REACT_APP_COORDINATION_SERVICE_URL || DEFAULT_HOST;

  }

  /**
   * Retrieve the current authentication token
   * @return string the current authentication token
   */
  getToken(): string {
    return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTY0MTk5ODI5MywianRpIjoiNmUxMzZmMGMtZWYyNS00ZTUyLTk2OGMtZDFhNGVkNTYzNzA0IiwidHlwZSI6ImFjY2VzcyIsInN1YiI6ImEwTDNZMDAwMDBuTzRxSFVBUyIsIm5iZiI6MTY0MTk5ODI5M30.Mt2xhgvdMCcAd23DOml3Xx3Dk7J9e7OWaxketCSieQ0";
  }
}
